import utils from 'utils'

class modalSynInvoicCtrl {
    constructor($scope, $uibModalInstance, items1, logger) {
        $scope.modalsend = {
            email: items1.custEmail,
            invoiceIds: items1.sendList,
            mobile: items1.phone,
        }
        // 关闭
        $scope.cancel = function cancel () {
            $uibModalInstance.dismiss('cancel')
        }
        // 确定
        $scope.ok = function ok () {
            let phone = $scope.modalsend.mobile
            if (phone && !(/^1[3456789]\d{9}$/.test(phone))) {
                logger.logError("手机号码有误")
                return
            }
            let email = $scope.modalsend.email
            const result2 = $scope.modalsend.email && utils.regExpTestEmail($scope.modalsend.email)
            if (email && !result2) {
                // alert('邮箱格式不正确')
                logger.logError('邮箱格式不正确')
                return
            }
            if (!phone && !email) {
                logger.logError('请填写手机号码或者邮箱')
                return
            }
            $uibModalInstance.close($scope.modalsend)
        }
    }
}

modalSynInvoicCtrl.$inject = ['$scope', '$uibModalInstance', 'items1', 'logger']
export default modalSynInvoicCtrl



// WEBPACK FOOTER //
// ./src/app/outputManage/billManage/openedInvoice/modalSureSend.js